import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

const shopify = getServiceProvider('shopifyStorefront');

export default createServiceProvider({
  ...shopify,
  titleToId: true,
  titleToNamespace: true,
  hasConnectionStatus: true,
  singleton: true,
  avatarPath: avatars.shopifyStorefront,
  logoPath: logos.shopifyStorefront
});
